export default __webpack_public_path__ + "images/matic_da7b87.svg";